export const SaleTypeSituation = {
    aprovado: "Aprovado(a)",
    cancelado: "Cancelado(a)",
    emAberto: "Em aberto",
    finalizado: "Finalizado(a)",
    faturado: "Faturado(a)"
}